export default __webpack_public_path__ + "static/media/Gopal-Mandir.f81d3c9a.jpg";